import styled from 'styled-components';

import {
  green,
  red,
  black,
  lightGreenSolid,
  border1,
} from 'utils/style/colors';
import { TaskStatus } from 'store/tasks/tasksType';
import { draftBackground } from '../TaskListView/styles';

interface ITotalProps {
  width: number;
}

interface IVerifyStatusProps {
  status: TaskStatus;
}

interface IProgressProps {
  color: string;
}

interface ITaskTitleProps {
  deleted: boolean;
  archived: boolean;
}

export const Total = styled('div')<ITotalProps>`
  width: ${(props) => props.width}%;
  height: 2px;
  background-color: ${green};
  position: absolute;
  top: 0;
`;

interface ITaskWrapperProps {
  draft?: boolean;
}
export const TaskWrapper = styled.div<ITaskWrapperProps>`
  border-radius: 2rem;
  margin: 1rem;

  border: ${border1};
  background: ${lightGreenSolid};
  background-image: ${(props) => (props.draft === true ? draftBackground : '')};
  color: ${black};
`;

export const ItemWrapper = styled('li')`
  min-height: 5rem;
  width: 100%;
  position: relative;
  transition: background-color 0.4s ease;
`;

export const TaskItem = styled('div')`
  flex: 1;
  display: flex;
  position: relative;
  justify-content: center;
  flex-direction: column;
  padding: 0 1em;
  //border-top: 1px solid #cccccc;
  & > a {
    color: ${black};
  }
`;

export const TaskTitle = styled('span')<ITaskTitleProps>`
  color: ${black};
  margin-right: 2.5rem;
  ${({ deleted }) =>
    deleted &&
    `
    color: ${red}
`}
  ${({ archived }) =>
    archived &&
    `
    color: gray;
  `}
`;

export const VerifyStatus = styled('span')<IVerifyStatusProps>`
  background-color: ${(props) => {
    switch (props.status) {
      case 'complete':
        return green;
      case 'rejected':
        return red;
      default:
        return 'transparent';
    }
  }};
  border: ${(props) =>
    props.status === 'complete' || props.status === 'rejected'
      ? 'none'
      : `2px solid ${green}`};
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 1em;
  width: 1em;
`;

export const Verify = styled('div')`
  position: relative;
  height: 1.2em;
  width: 1em;
  margin-right: 0.5em;
`;

export const DateContainer = styled('div')`
  width: 7em;
  text-align: center;
`;

export const TaskItemBody = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1.8rem;
  padding: 0.5rem 0;
  min-height: 3rem;
  word-break: break-word;
  & > div {
    //display: flex;
    align-items: center;
  }
`;

export const Progress = styled('span')<IProgressProps>`
  color: ${(props) => props.color};
  width: 3em;
  text-align: center;
  padding: 0 5px;
  border-left: 1px solid gainsboro;
  box-sizing: content-box;
  font-size: 0.9rem;
`;

export const TemplateDropdownWrapper = styled('div')`
  display: flex;
  align-items: center;
  & > *:nth-child(2) {
    margin-right: 0.5rem;
    height: 2.6rem;
  }
`;
